import * as React from "react";
import PropTypes from "prop-types";
import { AppBarIconWrapper } from "nx-components/AppBar";
import BackButtonResponder from "nx-components/BackButtonResponder";
import { IconThinChevronLeft } from "nx-components/Icons";
import { history } from "nexia_mobile/history";
import { getTransitionPromise } from "nexia_mobile/components/Routing/HistoryPageTransitionController";

export class DumbBackButton extends React.Component {
  static propTypes = {
    onTap: PropTypes.func, // () => void
    innerRef: PropTypes.func, // (?HTMLElement) => void
  };

  render() {
    const { onTap, innerRef } = this.props;

    return (
      <AppBarIconWrapper
        onTap={onTap}
        innerRef={innerRef}
        aria-label="Back"
        holdActiveUntil={getTransitionPromise}
      >
        <IconThinChevronLeft />
      </AppBarIconWrapper>
    );
  }
}

export default class BackButton extends React.Component {
  static propTypes = {
    onTap: PropTypes.func, // () => void
  };

  static defaultProps = {
    onTap: () => history.goBack(),
  };

  _isTopmostElement() {
    if (!this._el) {
      return false;
    }
    if (!document.body.contains(this._el)) {
      return false;
    }

    const buttonRect = this._el.getBoundingClientRect();
    const buttonCenterX = buttonRect.x + buttonRect.width / 2;
    const buttonCenterY = buttonRect.y + buttonRect.height / 2;

    const topmostElementAtButtonCenter = document.elementFromPoint(
      buttonCenterX,
      buttonCenterY
    );
    return this._el.contains(topmostElementAtButtonCenter);
  }

  render() {
    const { onTap } = this.props;

    return (
      <React.Fragment>
        <BackButtonResponder
          onPressed={() => {
            if (this._isTopmostElement()) {
              onTap();
            } else {
              // Something is covering the BackButton, like a SpinnerOverlay
              // background. Don't actually *do* anything, but still consider
              // the press handled, because we don't want to quit the app.
              // Unless a button is covering the back button, this behaves as
              // if the user tried to tap on the back button.
            }

            return { handled: true };
          }}
        />
        <DumbBackButton innerRef={(el) => (this._el = el)} onTap={onTap} />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TopBar/BackButton.jsx